import moment from "moment";
import "moment/locale/zh-cn"; // 添加日期使用环境为中文，否则周会重周日到周一并不是周一到周日的顺序
import download from "downloadjs";
import axios from "axios";
import store from "./store";
import i18n from "./lang";
String.prototype.trim = function () {
  return this.replace(/(^\s*)|(\s*$)/g, "");
};
String.prototype.ltrim = function () {
  return this.replace(/(^\s*)/g, "");
};
String.prototype.rtrim = function () {
  return this.replace(/(\s*$)/g, "");
};
var Mixin = {
  methods: {
    htmlDecode(text) {
      var temp = document.createElement("div");
      temp.innerHTML = text;
      var output = temp.innerText || temp.textContent;
      temp = null;
      return output;
    },
    translateYesOrNo(row, column) {
      return row[column.property] ? "Y" : "N";
    },
    formatDate(row, column) {
      return this._formatDate(row[column.property]);
    },
    formatDatetimeWithoutSecond(row, column) {
      return this._formatDatetimeWithoutSecond(row[column.property]);
    },
    formatDatetime(row, column) {
      return this._formatDatetime(row[column.property]);
    },
    formatTime(row, column) {
      return this._formatTime(row[column.property]);
    },
    formatTimeWithoutSecond(row, column) {
      return this._formatTimeWithoutSecond(row[column.property]);
    },
    formatDatetimeWithPattern(row, column, pattern) {
      return this._formatDatetimeWithPattern(row[column.property], pattern);
    },
    formatStatus(row, column, key) {
      return this._formatStatus(row[column.property], key);
    },
    localizeStatus(status) {
      const s = status.toLowerCase()
      if(s === "all") {
        return i18n.t('public.all')
      } else if(s === "active") {
        return i18n.t('public.active')
      } else if(s === "inactive") {
        return i18n.t('public.inactive')
      }
      return status
    },
    formatParseFloat(string) {
      return parseFloat(string);
    },
    formatTimeFrame(startTime, endTime) {
      let date = null;
      let start = null;
      let end = null;
      if (!startTime && !endTime) {
        return "";
      }
      if (startTime) {
        date = this._formatDate(startTime, "MM-DD");
      } else {
        date = this._formatDate(endTime, "MM-DD");
      }
      start = startTime ? this._formatTimeWithoutSecond(startTime) : "--";
      if (endTime) {
        let newEndTime = this._formatTimeWithoutSecond(endTime);
        if (newEndTime === "00:00") {
          end = "24:00";
        } else {
          end = this._formatTimeWithoutSecond(endTime);
        }
      } else {
        end = "--";
      }
      return date + " " + start + "~" + end;
    },
    // 非tab枚举值格式化
    _translateYesOrNo(value) {
      switch (value) {
        case 0:
          return "N";
        case 1:
          return "Y";
        case "N":
          return "N";
        case "Y":
          return "Y";
        default:
          return "";
      }
    },
    _formatDate(value, formater) {
      return value == null
        ? ""
        : moment(value).format(formater ? formater : "YYYY-MM-DD");
    },
    _formatDatetimeWithoutSecond(value) {
      return value == null ? "" : moment(value).format("YYYY-MM-DD HH:mm");
    },
    _formatDatetime(value) {
      return value == null ? "" : moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
    _formatDatetimeWithoutSecondZero(value) {
      return value == null ? "" : moment(value).format("YYYY-MM-DD HH:mm:00");
    },
    _formatTime(value) {
      return value == null ? "" : moment(value).format("HH:mm:ss");
    },
    _formatTimeWithoutSecond(value) {
      return value == null ? "" : moment(value).format("HH:mm");
    },
    _formatDatetimeWithPattern(value, pattern) {
      return value == null ? "" : moment(value).format(pattern);
    },
    _formatStatus(value, key) {
      const routeStatus = JSON.parse(localStorage.getItem("parameters"))[key];
      return value == null ? "" : routeStatus[value];
    },
    _formatTimeStamp(value) {
      return value ? parseInt(moment(value).format("x")) : null;
    },
    _duration(time) {
      //time 必须为时间戳 转换结果为：xx天xx小时xx分
      time = time / (1000 * 60);
      var day = parseInt(time / 60 / 24);
      var hour = parseInt((time / 60) % 24);
      var min = parseInt(time % 60);
      time = "";
      if (day > 0) {
        time = day + "day";
      }
      if (hour > 0) {
        time += hour + "hour";
      }
      if (min > 0) {
        time += parseFloat(min) + "min";
      }
      return time;
    },
    _durationEn(time) {
      //time 必须为时间戳 转换结果为：xx天xx小时xx分
      time = time / (1000 * 60);
      var day = parseInt(time / 60 / 24);
      var hour = parseInt((time / 60) % 24);
      var min = parseInt(time % 60);
      time = "";
      if (day > 0) {
        time = day + "day";
      }
      if (hour > 0) {
        time += hour + "hour";
      }
      if (min > 0) {
        time += parseFloat(min) + "min";
      }
      return time;
    },
    accAdd(arg1, arg2, fixedNo) {
      //js 加法计算 调用：accAdd(arg1,arg2) 返回值：arg1加arg2的精确结果
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      let value = null;
      if (fixedNo) {
        value = ((arg1 * m + arg2 * m) / m).toFixed(fixedNo);
      } else {
        value = ((arg1 * m + arg2 * m) / m).toFixed(2);
      }
      return value;
    },
    subtr(arg1, arg2, fixedNo) {
      //js 减法计算 subtr(arg1,arg2) 返回值：arg1减arg2的精确结果
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      let value = null;
      if (fixedNo) {
        value = ((arg1 * m - arg2 * m) / m).toFixed(fixedNo);
      } else {
        value = ((arg1 * m - arg2 * m) / m).toFixed(2);
      }
      return value;
    },
    accMul(arg1, arg2) {
      //js 乘法函数 调用：accMul(arg1,arg2) 返回值：arg1乘以arg2的精确结果
      var m = 0,
        s1 = arg1 ? arg1.toString() : "",
        s2 = arg2 ? arg2.toString() : "";
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
      );
    },
    accDiv(arg1, arg2) {
      //js 除法函数 accDiv(arg1,arg2) 返回值：arg1除以arg2的精确结果
      var t1 = 0,
        t2 = 0,
        r1,
        r2;
      try {
        t1 = arg1.toString().split(".")[1].length;
      } catch (e) {}
      try {
        t2 = arg2.toString().split(".")[1].length;
      } catch (e) {}
      r1 = Number(arg1.toString().replace(".", ""));
      r2 = Number(arg2.toString().replace(".", ""));
      return (r1 / r2) * Math.pow(10, t2 - t1);
    },
    formatCurrency(row, column) {
      let number = row[column.property];
      if (number == null || isNaN(number)) {
        return "0.00";
      }
      let numberString = "" + number.toFixed(2);
      let numeric = this.formatNumeric(numberString.split(".")[0]);

      return numeric + "." + numberString.split(".")[1];
    },
    formatNumber(row, column) {
      let number = row[column.property];
      if (isNaN(number)) {
        return "0";
      }
      let numberString = "" + number;
      if (numberString.indexOf(".") != -1) {
        return (
          this.formatNumeric(numberString.split(".")[0]) +
          "." +
          numberString.split(".")[1]
        );
      } else {
        return this.formatNumeric(number);
      }
    },
    formatPercentage(row, column) {
      let number = row[column.property];
      if (isNaN(number)) {
        return "0";
      }
      let numberString = "" + number * 100;
      if (numberString.indexOf(".") != -1) {
        return (
          this.formatNumeric(numberString.split(".")[0]) +
          "." +
          numberString.split(".")[1]
        );
      } else {
        return this.formatNumeric(number * 100);
      }
    },
    formatNumeric(number) {
      let result = [],
        counter = 0;
      number = (number || 0).toString().split("");
      for (let i = number.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(number[i]);
        if (!(counter % 3) && i != 0) {
          result.unshift(",");
        }
      }
      return result.join("");
    },
    isNumber(value) {
      return typeof value === 'number';
    },
    numberWithDecimal(x, decimal) {
      if(x == null || isNaN(x)) {
        return ''
      }
      x = Number(x)
      if(this.isNumber(decimal) && decimal > 0) {
        const hasDecimals = (x%1 != 0)
        x = x.toFixed(hasDecimals ? decimal : 0)
      }
      return x.toString()
    },
    numberWithCommas(x, decimal) {
      if(x == null || isNaN(x)) {
        return '-'
      }
      x = Number(x)
      if(this.isNumber(decimal) && decimal > 0) {
        const hasDecimals = (x%1 != 0)
        x = x.toFixed(hasDecimals ? decimal : 0)
      }
      return x.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
    },
    totalValueWithCommas(x) {
      return this.numberWithCommas(x, 2)
    },
    isEmpty(value) {
      var type;
      if (value == null) {
        // 等同于 value === undefined || value === null
        return true;
      }
      type = Object.prototype.toString.call(value).slice(8, -1);
      switch (type) {
        case "String":
          return !$.trim(value);
        case "Array":
          return !value.length;
        case "Object":
          return $.isEmptyObject(value); // 普通对象使用 for...in 判断，有 key 即为 false
        default:
          return false; // 其他对象均视作非空
      }
    },
    delObjEmptyElement(obj) {
      for (const o in obj) {
        if (this.isEmpty(obj[o])) {
          delete obj[o];
        }
      }
    },
    getUrlKey(paras) {
      var url = location.href;
      var paraString = url
        .substring(url.indexOf("?") + 1, url.length)
        .split("&");
      var paraObj = {};
      var j;
      for (var i = 0; (j = paraString[i]); i++) {
        paraObj[j.substring(0, j.indexOf("=")).toLowerCase()] = j.substring(
          j.indexOf("=") + 1,
          j.length
        );
      }
      var returnValue = paraObj[paras.toLowerCase()];
      if (typeof returnValue == "undefined") {
        return "";
      } else {
        return returnValue;
      }
    },
    multiLevelJump(lable, name, url) {
      let tab = {
        label: lable,
        name: name,
        url: url,
        isActive: false,
        isEnable: true,
      };
      this.$store.dispatch("addToTab", tab);
      this.$store.dispatch("setTabActive", tab);
      this.$store.dispatch("setTabViewName", [tab.name, tab.name]);
      this.$router.push({ name });
    },
    checkPlateNo(value) {
      let isPlateNo =
        /((^(\d{1})([\u0E01-\u0E23|\u0E25|\u0E27-\u0E2E']{2})(\d{4})$)|(^(\d{2})[-\s](\d{4})$))|(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}(,[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1})?$)/;
      if (!isPlateNo.test(value)) {
        this.$message({
          showClose: true,
          type: "error",
          message: "请输入正确的车牌号！",
        });
        return false;
      } else {
        return true;
      }
    },
    formatTimeToDate(val) {
      try {
        let newTime = null;
        let temp = null;
        if (val) {
          temp = val.split(":");
        }
        let hour = temp[0] * 1;
        let minute = temp[1];
        let day = parseInt(hour / 24);
        let tempHour = hour % 24;
        if (hour < 24) {
          if (val == "00:00") {
            newTime = "0:0";
          } else {
            newTime = val;
          }
        }
        if (day == 1) {
          // 1-9的时间要在最前面加0->01:11
          // if (tempHour > 0 && tempHour < 10) {
          //   tempHour = '0' + tempHour
          // }
          newTime = "次日" + tempHour + ":" + minute;
        } else if (day > 1) {
          // if (tempHour > 0 && tempHour < 10) {
          //   tempHour = '0' + tempHour
          // }
          newTime = "次" + day + "日" + tempHour + ":" + minute;
        }
        return newTime;
      } catch (err) {
        return val;
      }
    },
    formatTimeToDayNum(val) {
      let temp = null;
      if (val) {
        temp = val.split(":");
      }
      return this.formatToDayNum(temp);
    },
    formatToDayNum(temp) {
      let newTime = null;
      if (!temp) return [0, "--"];
      if (temp && temp.length == 2) {
        let hour = temp[0] * 1;
        let minute = temp[1] * 1;
        let day = parseInt(hour / 24);
        let tempHour = hour % 24;
        if (tempHour < 10) tempHour = "0" + tempHour;
        if (minute < 10) minute = "0" + minute;
        newTime = tempHour + ":" + minute;
        return [day, newTime];
      }
      return [0, "--"];
    },
    formatMinsecendsToDayNum(val) {
      if (!val) return [0, "--"];
      let hour = parseInt(val / 3600000);
      let minutes = parseInt((val % 3600000) / 60000);
      let temp = [hour, minutes];
      return this.formatToDayNum(temp);
    },
    formatTemp(item) {
      let value = "";
      if (
        (item.upperLimit || item.upperLimit === 0) &&
        (item.lowerLimit || item.lowerLimit === 0)
      ) {
        value = item.lowerLimit + "℃-" + item.upperLimit + "℃";
      } else if (item.upperLimit && this.isEmpty(item.lowerLimit)) {
        value = "below" + item.upperLimit + "℃";
      } else if (this.isEmpty(item.upperLimit) && item.lowerLimit) {
        value = "more than" + item.lowerLimit + "℃";
      } else if (!item.upperLimit && !item.lowerLimit) {
        value = "unlimited";
      } else {
        value = "";
      }
      return value;
    },
    formatMinuteToHourAndMinute(val) {
      // demo formatMinuteToHourAndMinute(552) => "9小时12分钟"
      if (!val) {
        return "";
      }
      let newTime = null;
      let sourceMinute = val * 1;
      let hour = parseInt(sourceMinute / 60);
      let minute = sourceMinute % 60;
      if (hour > 0 && minute > 0) {
        newTime = hour + "hour" + minute + "min";
      } else if (hour <= 0 && minute > 0) {
        newTime = minute + "min";
      } else {
        newTime = hour + "hour";
      }
      return newTime;
    },
    getHHmmSencod(str) {
      if (str) {
        let values = str.split(":");
        if (values.length != 2) return 0;
        return parseInt(values[0]) * 3600 + parseInt(values[1]) * 60;
      }
      return 0;
    },
    calcOnTime(timeWindowStr, arriveTimeTemp) {
      let arriveTime = this.getHHmmSencod(arriveTimeTemp);
      let timeWindow = [
        this.getHHmmSencod(timeWindowStr[0]),
        this.getHHmmSencod(timeWindowStr[1]),
      ];
      let timeWindow0 = timeWindow[0] % 86400;
      let timeWindow1 = timeWindow[1] % 86400;

      arriveTime = arriveTime % 86400;
      let delta = 0,
        delta1,
        delta2;
      if (timeWindow0 > timeWindow1) {
        // 跨天工作
        delta1 = timeWindow0 - arriveTime;
        delta2 = arriveTime - timeWindow1;
      } else {
        delta1 = timeWindow0 - arriveTime;
        delta2 = arriveTime - timeWindow1;
        if (delta1 > 0) {
          delta2 = arriveTime - (timeWindow1 - 86400);
        } else if (delta2 > 0) {
          delta1 = timeWindow0 + 86400 - arriveTime;
        }
      }

      if (delta1 > 0 && delta2 > 0) {
        if (delta1 > delta2) {
          delta = delta2; // 迟到
        } else {
          delta = -delta1; // 早到
        }
      }
      return delta;
    },
    countingTransportEarliestReceivedDt(items) {
      if (!items) return;
      items.map((val) => {
        /**
         * 要求收货时间范围是：
              用单据的最早收货时间和最晚收货时间拼接，如果没有最早时间就取最晚收货日期
            红色字为收货最晚时间 的差异天数，是同一个天就是，下面这边表达没有+N，N=0时不显示
         */
        if (val.latestReceivedDt) {
          let tempLatestReceivedDt = parseInt(val.latestReceivedDt / 1000);
          tempLatestReceivedDt =
            tempLatestReceivedDt - (tempLatestReceivedDt % 60);
          let tempEarliestReceivedDt = val.earliestReceivedDt;
          if (!tempEarliestReceivedDt) {
            if (tempLatestReceivedDt % 86400 == 57600) {
              tempEarliestReceivedDt = tempLatestReceivedDt;
              tempLatestReceivedDt = tempLatestReceivedDt + 86400;
            } else {
              tempEarliestReceivedDt =
                tempLatestReceivedDt - ((tempLatestReceivedDt - 57600) % 86400);
            }

            val.earliestReceivedDt = tempEarliestReceivedDt * 1000;
            val.latestReceivedDt = tempLatestReceivedDt * 1000;
          }
          let day =
            parseInt((val.latestReceivedDt - 57600000) / 86400000) -
            parseInt((val.earliestReceivedDt - 57600000) / 86400000);
          if (day < 0) day = 0;
          this.$set(val, "day", day);
        }
      });
    },
    __downloadFile(url, fileName, path, func) {
      if (url && path && path != "") {
        fileName = fileName || url.split("/").pop().split("?")[0];
        var ajax = new XMLHttpRequest();
        ajax.open("GET", url, true);
        ajax.responseType = "blob";
        ajax.onload = function (e) {
          var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
          var isFFIE =
            userAgent.indexOf("Firefox") > -1 ||
            !!window.ActiveXObject ||
            "ActiveXObject" in window; // 判断是否Firefox或IE浏览器
          func && func.call(null, true);
          if (isFFIE) {
            let types = path.substring(path.lastIndexOf("."), path.length);
            download(
              e.target.response,
              fileName + types,
              "application/octet-stream"
            );
          } else {
            download(e.target.response, fileName, "application/octet-stream");
          }
        };
        setTimeout(function () {
          ajax.send();
        }, 0);
        return ajax;
      } else {
        func && func.call(null, false);
        this.$message({
          message: res.message,
          type: "error",
        });
      }
    },
    setCalcValue(billingCost, adjustCost, beforeAdjustCost) {
      //billingCost 计算费用
      let adjustCosts = null; //调整费用
      let finalCosts = null; //最终费用
      //调整费用计算
      if (adjustCost != null || beforeAdjustCost != null) {
        adjustCosts = this.$root.subtr(adjustCost, beforeAdjustCost) * 1;
      }
      //最终费用计算
      if (adjustCosts != null || billingCost != null) {
        finalCosts = this.$root.accAdd(billingCost, adjustCosts) * 1;
      }
      //计算费用
      if (billingCost == null) {
        billingCost = "--";
      }
      //调整费用
      if (adjustCosts == null) {
        adjustCosts = "--";
      }
      //最终费用
      if (finalCosts == null) {
        finalCosts = "--";
      }
      return [billingCost, adjustCosts, finalCosts];
    },
    setHeaderInitData(tableCode, headerlist) {
      let customHeader = {};
      if (localStorage.getItem("customHeader")) {
        customHeader = JSON.parse(localStorage.getItem("customHeader"));
        customHeader[tableCode] = {
          tableCode: tableCode,
          val: headerlist,
        };
      } else {
        customHeader[tableCode] = {
          tableCode: tableCode,
          val: headerlist,
        };
      }
      localStorage.setItem("customHeader", JSON.stringify(customHeader));
    },
    setTableHeader(tableCode, newWidth, prop, headerList) {
      headerList.map((item) => {
        if (item.prop == prop) {
          item.width = newWidth;
        }
      });
      let params = {
        tableCode: tableCode,
        val: JSON.stringify(headerList),
      };
      axios.post("/v1/tableheadersetting", params).then(
        (response) => {
          this.setHeaderInitData(tableCode, JSON.stringify(headerList));
        },
        (err) => {
          this.isLoading = false;
          console.log(err);
        }
      );
    },
    getHeadeCacheData(tableCode) {
      // 在获取表头初始化的缓存数据
      let headerList = null;
      if (localStorage.getItem("customHeader")) {
        let customHeader = JSON.parse(localStorage.getItem("customHeader"));
        if (customHeader[tableCode] && customHeader[tableCode].val) {
          headerList = JSON.parse(customHeader[tableCode].val);
        }
      }
      return headerList;
    },
    removeHeaderItem(headerTemp, propKey) {
      if (!headerTemp || !propKey) return;
      let propKeyTemp = propKey.split(",");
      for (let propKeyTempIndex in propKeyTemp) {
        let index = null;
        for (let i = 0; i <= headerTemp.length; i++) {
          let header = headerTemp[i];
          if (propKeyTemp[propKeyTempIndex] == header.prop) {
            index = i;
            break;
          }
        }
        if (null != index) headerTemp.splice(index, 1);
      }
    },
    mergeHeader(sourceArr, tableCode, fixHeaderCnt) {
      // 通过tableCode拿列表表头的缓存数据
      let cacheArr = this.getHeadeCacheData(tableCode);
      let obj = {};
      // 将不参与循环的前面n个表头设置成负数fixHeaderCnt为固定数量
      for (let i = 0; i < fixHeaderCnt; i++) {
        sourceArr[i].seq = -1000 + i;
      }
      // 给除了固定的列设置seq
      let seq = 1;
      sourceArr.forEach((o) => {
        if (!o.type) {
          obj[o.prop] = o;
          o.seq = seq;
          seq++;
        }
      });
      // 合并源数据和缓存数据
      if (cacheArr) {
        cacheArr.forEach((o) => {
          if (obj[o.prop]) {
            let v = obj[o.prop];
            v.show = o.show;
            v.seq = o.seq;
            if (o.width) {
              v.width = o.width;
            }
          }
        });
      }
      // 因为老版本el-table渲染问题，需要倒序一下才能正确渲染
      let newSourceArr = _.sortBy(sourceArr, function (item) {
        return item["seq"];
      });
      return newSourceArr;
      // return sourceArr;
    },
    getTmsExtMeta(extKey) {
      // 在获取表头初始化的缓存数据
      let meta = null;
      if (localStorage.getItem("TmsExtMeta")) {
        let metaTemp = JSON.parse(localStorage.getItem("TmsExtMeta"));
        meta = metaTemp[extKey];
      }
      return meta ? meta : [];
    },
    getTimeArr(val) {
      switch (val) {
        case "TODAY":
          // 今日
          let todatyStart = new Date(
            moment(new Date()).format("YYYY-MM-DD 00:00:00")
          );
          let todatyEnd = new Date(
            moment(new Date()).format("YYYY-MM-DD 23:59:59")
          );
          return [todatyStart, todatyEnd];
        case "YESTERDAY":
          // 昨日
          let yesterdatyStart = new Date(
            moment(new Date()).add(-1, "days").format("YYYY-MM-DD 00:00:00")
          );
          let yesterdatyEnd = new Date(
            moment(new Date()).add(-1, "days").format("YYYY-MM-DD 23:59:59")
          );
          return [yesterdatyStart, yesterdatyEnd];
        case "LATEST_2":
          // 近3日
          let latest_2Start = new Date(
            moment(new Date()).add(-1, "days").format("YYYY-MM-DD 00:00:00")
          );
          let latest_2End = new Date(
            moment(new Date()).format("YYYY-MM-DD 23:59:59")
          );
          return [latest_2Start, latest_2End];
        case "LATEST_3":
          // 近3日
          let latest_3Start = new Date(
            moment(new Date()).add(-2, "days").format("YYYY-MM-DD 00:00:00")
          );
          let latest_3End = new Date(
            moment(new Date()).format("YYYY-MM-DD 23:59:59")
          );
          return [latest_3Start, latest_3End];
        case "LATEST_5":
          // 近5日
          let latest_5Start = new Date(
            moment(new Date()).add(-4, "days").format("YYYY-MM-DD 00:00:00")
          );
          let latest_5End = new Date(
            moment(new Date()).format("YYYY-MM-DD 23:59:59")
          );
          return [latest_5Start, latest_5End];
        case "LATEST_7":
          // 近7日
          let latest_7Start = new Date(
            moment(new Date()).add(-6, "days").format("YYYY-MM-DD 00:00:00")
          );
          let latest_7End = new Date(
            moment(new Date()).format("YYYY-MM-DD 23:59:59")
          );
          return [latest_7Start, latest_7End];
        case "LATEST_10":
          // 近10日
          let latest_10Start = new Date(
            moment(new Date()).add(-9, "days").format("YYYY-MM-DD 00:00:00")
          );
          let latest_10End = new Date(
            moment(new Date()).format("YYYY-MM-DD 23:59:59")
          );
          return [latest_10Start, latest_10End];
        case "LATEST_30":
          // 近30日
          let latest_30Start = new Date(
            moment(new Date()).add(-29, "days").format("YYYY-MM-DD 00:00:00")
          );
          let latest_30End = new Date(
            moment(new Date()).format("YYYY-MM-DD 23:59:59")
          );
          return [latest_30Start, latest_30End];
        case "THIS_WEEK":
          // 本周
          let thisWeekStart = new Date(
            moment(moment().startOf("week")).format("YYYY-MM-DD 00:00:00")
          );
          let thisWeekEnd = new Date(
            moment(moment().endOf("week")).format("YYYY-MM-DD 23:59:59")
          );
          return [thisWeekStart, thisWeekEnd];
        case "BEFORE_WEEK":
          // 上周
          let beforeWeekStart = new Date(
            moment(
              moment()
                .week(moment().week() - 1)
                .startOf("week")
            ).format("YYYY-MM-DD 00:00:00")
          );
          let beforeWeekEnd = new Date(
            moment(
              moment()
                .week(moment().week() - 1)
                .endOf("week")
            ).format("YYYY-MM-DD 23:59:59")
          );
          return [beforeWeekStart, beforeWeekEnd];
        case "THIS_MONTH":
          // 本月
          let thisMonthStart = new Date(
            moment().startOf("month").format("YYYY-MM-DD 00:00:00")
          );
          let thisMonthEnd = new Date(
            moment().endOf("month").format("YYYY-MM-DD 23:59:59")
          );
          return [thisMonthStart, thisMonthEnd];
        case "BEFORE_MONTH":
          // 上月
          let beforeMonthStart = new Date(
            moment()
              .month(moment().month() - 1)
              .startOf("month")
              .format("YYYY-MM-DD 00:00:00")
          );
          let beforeMonthEnd = new Date(
            moment()
              .month(moment().month() - 1)
              .endOf("month")
              .format("YYYY-MM-DD 23:59:59")
          );
          return [beforeMonthStart, beforeMonthEnd];
        case "THIS_YEAR":
          // 今年
          let thisYearStart = new Date(
            moment(moment().year(moment().year()).startOf("year")).format(
              "YYYY-MM-DD 00:00:00"
            )
          );
          let thisYearEnd = new Date(
            moment(moment().year(moment().year()).endOf("year")).format(
              "YYYY-MM-DD 23:59:59"
            )
          );
          return [thisYearStart, thisYearEnd];
        default:
          //   默认
          let defaultYearStart = new Date(
            moment(moment().year(moment().year()).startOf("year")).format(
              "YYYY-MM-DD 00:00:00"
            )
          );
          let defaultYearEnd = new Date(
            moment(moment().year(moment().year()).endOf("year")).format(
              "YYYY-MM-DD 23:59:59"
            )
          );
          return [defaultYearStart, defaultYearEnd];
      }
    },
    noToChinese(num) {
      if (!/^\d*(\.\d*)?$/.test(num)) {
        alert("Number is wrong!");
        return "Number is wrong!";
      }
      var AA = new Array(
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九"
      );
      var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
      var a = ("" + num).replace(/(^0*)/g, "").split("."),
        k = 0,
        re = "";
      for (var i = a[0].length - 1; i >= 0; i--) {
        switch (k) {
          case 0:
            re = BB[7] + re;
            break;
          case 4:
            if (
              !new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0])
            )
              re = BB[4] + re;
            break;
          case 8:
            re = BB[5] + re;
            BB[7] = BB[5];
            k = 0;
            break;
        }
        if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0)
          re = AA[0] + re;
        if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
        k++;
      }
      if (a.length > 1) {
        //加上小数部分(如果有小数部分)
        re += BB[6];
        for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
      }
      return re;
    },
  },
};
export default Mixin;



// WEBPACK FOOTER //
// ./src/mixin.js